<template>
  <div>
    <div class="brand_infoBox text-center mt50">
      <h1 class="brand_logo"></h1>
    </div>
    <div class="fullbox" :style="{'width': window.width + 'px', 'height': windowHeight + 'px'}">
      <div class="fullbox_cont vin_register">
        <h3 class="title_base">{{ $t('frameNoRecheck.title') }}</h3>
        <ul class="register_list list-unstyled">
          <li>{{this.getBikeFrameNo}}</li>
        </ul>
        <div class="jumbotron register_notice mt50">
          <div class="container-fluid">
            <p class="red"><i class="icon-warning"></i> {{ $t('frameNoRecheck.notice') }}</p>
            <p>{{ $t('frameNoRecheck.makeSureFrameNumber') }}</p>
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn_normalBtn" type="button" @click="funcOk" :disabled="frameNumChecked">{{ $t('frameNoRecheck.btnOk') }}</button>
        </div>
        <div class="register_over">
          <i class="icon-reg_bike"></i>
          <p>{{ $t('frameNoRecheck.tips') }}</p>
        </div>
      </div>
    </div>
    <uiv-modal v-model="modalOpenDisconnect" class="v-modal-style" :backdrop="false">
      <h4 slot="header" class="modal-title">{{ modal.data.title }}</h4>
      <p slot="default">{{ modal.data.content }}</p>
      <template slot="footer">
        <button
          id="btnOK"
          type="button"
          class="btn btn-default mb20"
          @click="funcOkBtnDialog">{{ modal.btn.ok }}</button>
      </template>
    </uiv-modal>
    <Loading :loadingText="loadingText" v-if="pageLoading"/>
  </div>
</template>
<script>
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import * as connectBikeAPI from '@/api/connect-bike';
import { mapGetters } from 'vuex';
import { bikeRecheckVINAPI } from '@/mixins/websocket-api';
import { windowsResize } from '@/mixins/windows-resize';
import Loading from '@/components/Loading.vue';

export default {
  name: 'VinRecheck',
  mixins: [bikeRecheckVINAPI, windowsResize],
  data () {
    return {
      NewBikeID: '',
      loadingText: '',
      frameNumChecked: false,
      pageLoading: false,
      modalOpenDisconnect: false,
      modal: {
        data: {
          title: this.$t('bikeOverview.modalTitle'),
          content: this.$t('bikeOverview.modalContent')
        },
        btnAction: {
          ok: this.funcCloseDialog,
          cancel: this.funcCloseDialog
        },
        btn: {
          ok: this.$t('bikeOverview.modalBtnOk'),
          cancel: this.$t('bikeOverview.modalBtnCancel')
        }
      }
    };
  },
  components: {
    Loading
  },
  computed: {
    ...mapGetters({
      getBikeFrameNo: 'bikeConnect/getBikeFrameNo',
      getBikeVINsituation: 'bikeConnect/getBikeVINsituation',
      getDeviceInfo: 'bikeConnect/getDeviceInfo',
      getBikeId: 'bikeConnect/getBikeId'
    }),
    windowHeight () {
      let oriHeight = this.window.height;
      if (oriHeight !== null) {
        oriHeight -= 152;
      }
      return oriHeight;
    }
  },
  methods: {
    funcOk () {
      this.frameNumChecked = true;
      this.funcBindBikeId_API();
    },
    // checkVINsituation(){
    //   this.pageLoading = true
    //   switch (this.getBikeVINsituation.VIN_Type){
    //     case '1':
    //         this.ws.WriteFrameNo(this.getBikeFrameNo)
    //         break
    //     case '3-1':
    //         this.ws.WriteFrameNo(this.getBikeFrameNo)
    //         break
    //     case '3':
    //         this.funcBindBikeId_API()
    //         break
    //     }
    // },
    async funcBindBikeId_API () {
      // 綁定 BikeID FrameNo
      let message = Object.assign(this.getDeviceInfo, { 'BikeFID': this.getBikeFrameNo });
      const encryptData = funcEncryptData(message);
      // console.log('funcBindBikeId_API',message)
      try {
        const data = await connectBikeAPI.bindBikeId(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        // console.log("TCL: funcBindBikeId_API -> data", data)
        if (data.ErrorCode === 0) {
          clearInterval(this.timeInterval);
          const vin = data.frameNumber;
          this.NewBikeID = data.NewBikeId;
          this.ws.WriteFrameNo(vin);
          this.$store.dispatch('bikeConnect/setBikeFrameNo', vin);
        } else if (data.ErrorCode === 10013) {
          // different Bike model
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'PNError' } });
        } else {
          this.$store.dispatch('bikeConnect/setConnFail', '[B01] ' + data.ErrorCode);
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
        }
      } catch (e) {
        this.$store.dispatch('bikeConnect/setConnFail', '[B01]');
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
      }
    },
    async funcWriteBikeId_API () {
      // 如果與 DB給的BikeID不同，則重新寫入console
      if (this.getBikeId !== this.NewBikeID) {
        this.ws.WriteBikeId(this.NewBikeID);
      } else {
        this.ws.GetSystemInfo();
      }
    },
    funcOkBtnDialog () {
      this.modalOpenDisconnect = false;
      this.$router.push('/connect');
    },
    async funcBindBikeModel () {
      let bikeFID = { FrameNo: this.getBikeFrameNo };
      const encryptData = funcEncryptData(bikeFID);
      const data = await connectBikeAPI.getBikeModel(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      if (data.ErrorCode === 0) {
        this.$store.dispatch('bikeInformation/addBikeModel', data.BikeModel);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fullbox {
  position: relative;
  overflow: hidden;
}
</style>
